/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Header,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import SizeSuffix from '../../../components/SizeSuffix';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { translateModels } from '../../../utils/translation';
import { layoutAreaValue, layoutLandAreaValue } from '../../../utils/unitLayout';

class LayoutTitle extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data;
    return {
      data,
    };
  }
  constructor(props) {
    super(props);
    const state = LayoutTitle.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = LayoutTitle.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  render() {
    const { t } = this.props;
    const { data } = this.state;
    const isVietnam = this.props.auth.company && this.props.auth.company.countryCode.toUpperCase() === 'VN';
    const columnStyle = { paddingBottom: '0' };
    return (
      <Grid>
        <Grid.Row style={{ paddingBottom: '0' }}>
          <Grid.Column textAlign="center" style={columnStyle}>
            {
              data ? (
                <div>
                  <Header as="h3" style={{ marginBottom: '0' }}>{data ? data.name : ''}</Header>
                  {/* CPI-1208: the Vietnamese layout header carries NSA and NFA; every other
                      company keeps Build Up Area and Land Area, unchanged. Which pair is read is
                      utils/unitLayout's decision, so this header cannot drift from the list row,
                      the form and Compare. */}
                  {
                    layoutAreaValue(isVietnam, data) ? (
                      <p style={{ margin: 0 }}>
                        <span>{isVietnam ? translateModels(t, 'nsa', 'projectUnitLayout') : translateModels(t, 'size', 'projectUnitLayout')} </span>
                        <SizeSuffix
                          size={layoutAreaValue(isVietnam, data)}
                          suffix={data.project ? data.project.sizeSuffix : null}
                          isVietnam={isVietnam}
                        />
                      </p>
                    ) : null
                  }
                  {
                    layoutLandAreaValue(isVietnam, data) ? (
                      <p>
                        <span>{isVietnam ? translateModels(t, 'nfa', 'projectUnitLayout') : translateModels(t, 'landArea', 'projectUnitLayout')} </span>
                        <SizeSuffix
                          size={layoutLandAreaValue(isVietnam, data)}
                          suffix={data.project ? data.project.sizeSuffix : null}
                          isVietnam={isVietnam}
                        />
                      </p>
                    ) : null
                  }
                </div>
              ) : ''
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
])(connect(LayoutTitle.mapStateToProps)(LayoutTitle));



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/LayoutTitle.jsx